<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import Button from '../Vehicles/Button.svelte';
    import ButtonBack from '../../shared/ButtonBack.svelte';
    import MessageInline from '../../shared/Messages/MessageInline.svelte';
    import TemplateRow from '../../shared/TemplateRow.svelte';

    export let isOpen: boolean = false;
    export let onClick: (action: string) => void = () => {};
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            <h2 style="text-align: center;">{$_('unsaved_route_order_modifications')}</h2>

            <TemplateRow justifyContent={'center'}>
                <MessageInline text={$_('unsaved_route_order_modifications_info')} />
            </TemplateRow>

            <div class="actions">
                <ButtonBack
                    text={$_('Cancel')}
                    showIcon={false}
                    on:click={() => {
                        onClick('cancel');
                        closeModal();
                    }}
                />
                <ButtonBack
                    text={$_('discard_changes')}
                    showIcon={false}
                    on:click={() => {
                        onClick('discard');
                        closeModal();
                    }}
                />
                <ButtonMain
                    text={$_('save_changes')}
                    disabled={false}
                    showIcon={false}
                    on:click={() => {
                        onClick('commit');
                        closeModal();
                    }}
                />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        width: 590px;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
    }

    .actions {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        column-gap: 10px;
    }
</style>
